import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutstationRoutingModule } from './outstation-routing.module';
import { ViewOutstationComponent } from './view-outstation/view-outstation.component';
import { AddOutstationComponent } from './add-outstation/add-outstation.component';
import { UploadOutstationComponent } from './upload-outstation/upload-outstation.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { StationLookupComponent } from './station-lookup/station-lookup.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FamilyLookupComponent } from './family-lookup/family-lookup.component';
import { OutstationDetailsComponent } from './outstation-details/outstation-details.component';
import { FamilyMembersComponent } from './family-members/family-members.component';
import { GroupLookupComponent } from './group-lookup/group-lookup.component';
import { FamilyCheckComponent } from './family-check/family-check.component';
import { CommunityCheckComponent } from './community-check/community-check.component';
import { GroupCheckComponent } from './group-check/group-check.component';
import { LocationLookupComponent } from './location-lookup/location-lookup.component';
import { DeleteOutstationComponent } from './delete-outstation/delete-outstation.component';
import { UpdatOutstationComponent } from './updat-outstation/updat-outstation.component';
import { OutstationWidgetsComponent } from './outstation-widgets/outstation-widgets.component';
import { DashboardModule } from '../dashboard/dashboard.module';


@NgModule({
  declarations: [
    ViewOutstationComponent,
    AddOutstationComponent,
    UploadOutstationComponent,
    StationLookupComponent,
    FamilyLookupComponent,
    OutstationDetailsComponent,
    FamilyMembersComponent,
    GroupLookupComponent,
    FamilyCheckComponent,
    CommunityCheckComponent,
    GroupCheckComponent,
    LocationLookupComponent,
    DeleteOutstationComponent,
    UpdatOutstationComponent,
    OutstationWidgetsComponent
  ],
  imports: [
    CommonModule,
    OutstationRoutingModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatTableExporterModule,
    MatIconModule,
    MatMenuModule,
    ComponentsModule,
    SharedModule,
    CdkAccordionModule,
    DragDropModule,
    MatSelectModule,
    MatDialogModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    PerfectScrollbarModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDatepickerModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatStepperModule,
    DashboardModule
    
  

    
  ],
})
export class OutstationModule {}
